import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useGET_peerAssessmentsQuery } from 'redux/api/peerAssessmentsApi'
import ModelAnswerForm from 'components/organisms/forms/ModelAnswerForm'
import DialogPopup from 'components/molecules/DialogPopup'
import { Accordion, AccordionDetails, AccordionSummary, Button } from '@mui/material'
import { Delete, ExpandMore } from '@mui/icons-material'


interface IProps {
  submissionId?: string
}

const slideProps = {
  mountOnEnter: true,
  unmountOnExit: true,
  timeout: { enter: 225, exit: 195 }
};

const SubmissionPeerAssessments: FC<IProps> = ({ submissionId }) => {
  const { t } = useTranslation()

  const {  data: peerAssessments } = useGET_peerAssessmentsQuery({id: submissionId.toString()})
  const data = peerAssessments?.results ?? []

  return (
    <>
      {data.map((assessment) => 
                          <Accordion 
                            TransitionProps={slideProps}
                            key={assessment.id} >
                            <AccordionSummary expandIcon={<ExpandMore />}>
                                 {t('common.assessed-peer')}: {assessment.graded_student.title}
                            </AccordionSummary>
                            <AccordionDetails>  
                                <>
                                  <span dangerouslySetInnerHTML={{ __html: assessment.grade_comment }} />

                                  <div style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>{t('common.grade')}: {assessment.grade_percentage}%</div>
                                </>   

                            </AccordionDetails>
                          </Accordion>  
                        ) 
        }  
    </>
  )
}

export default SubmissionPeerAssessments
